import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import { useNavigate } from "react-router-dom";
import { fetchPayment, setAmount } from '../slices/payment.slice';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { removeComma, separateNumber } from '../helpers/mmg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ErrorIcon from '@mui/icons-material/Error';
import queryString from 'query-string';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, MenuItem, Select } from '@mui/material';
import { Add } from '@mui/icons-material';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import LinearProgress from '@mui/material/LinearProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import BeenhereIcon from '@mui/icons-material/Beenhere';

import { clearChangePass, resetChangePassResultBox, setChangePassData, setChangePassResultBox, submitChangePass } from '../slices/changePass.Slice';

export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const ChangePass = () => {

  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'));
  const changePass = useSelector(x => x.changePass);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  let navigate = useNavigate();

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");



   useEffect(() => {

    
      //dispatch(clearSelectedInvoice());
      //dispatch(fetchInvoice({saleDocId: entityId, saleDocType : 2 , authUser}));
      
     // getPaymentTestURL
    

   }, []);


   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
});

const handleChangeOldPass = (e) =>{
  dispatch(setChangePassData({ ReNewPass : changePass.reNewPass , OldPass : e.target.value , NewPass : changePass.newPass  }))
}
const handleChangeNewPass = (e) =>{
  dispatch(setChangePassData({ ReNewPass : changePass.reNewPass , OldPass : changePass.oldPass , NewPass : e.target.value  }))
}
const handleChangeReNewPass = (e) =>{
  dispatch(setChangePassData({ ReNewPass : e.target.value , OldPass : changePass.oldPass , NewPass : changePass.newPass  }))
}

const handleClick = (e) =>{

  e.preventDefault();
  setOpen(true);

}


const handleYes = () => {
  setOpen(false);
  var errors = [];
  console.log(errors);
  if(errors.length === 0){
    dispatch(submitChangePass({ p : changePass.newPass , authUser}));
  }else{
    var errorMessage = '';
    errors.map((err) => {
      errorMessage += err + '</hr>';
    });
    console.log(errorMessage);
    dispatch(setChangePassResultBox({message : errorMessage , type : 1}));
  }
};

const handleClose = () => {
  setOpen(false);
};
const handleNo = () => {
  setOpen(false);
};

const handleCloseMessageBox = (e) =>{
  dispatch(resetChangePassResultBox());
}
const handleCloseMessageBoxLoadAgain = (e) =>{
  dispatch(resetChangePassResultBox());
  dispatch(clearChangePass());
}


return (
    <>

<ThemeProvider theme={mdTheme}>
<br/><br/><br/><br/><br/><br/>
  <Box sx={{ flexGrow: 1 }}>
  <Grid container
    justify="center"
    style={{ minHeight: '100vh' }}>
              <Grid item xs={12}>           
 {changePass.loading ?   <Backdrop 
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>  : "" }
        <Card sx={{ minWidth: 275 }}>
      <CardContent
       style={{textAlign: 'center'}}
      >
        <Typography variant="h6" component="div">
        <AttachMoneyIcon sx={{ color: "#3F51B5" }} />    از طریق فرم زیر می توانیداقدام به تغییر رمز عبور خود نمایید
        </Typography>
        <hr/>
        <br/>
        <br/>
        <br/>
      <TextField
          type="password"
          id="outlined-helperText"
          label="رمز عبور جاری"
          value={changePass.oldPass}
          onChange={handleChangeOldPass}
        />
        <br/>
        <TextField
          type="password"
          id="outlined-helperText"
          label="رمز عبور جدید"
          value={changePass.newPass}
          onChange={handleChangeNewPass}
        />
        <br/>
        <TextField
          type="password"
          id="outlined-helperText"
          label="تکرار عبور جدید"
          value={changePass.reNewPass}
          onChange={handleChangeReNewPass}
        />
      {changePass.error ? 
      <Typography component="div" sx={{ color: "#E53935" }}>
        <ErrorIcon sx={{ color: "#E53935" }} />خطا در ارسال درخواست &nbsp; {changePass.errorMessage}
        </Typography>  : "" }
      </CardContent>
      <Box textAlign='center'>
      <Button variant="outlined" href="#outlined-buttons" onClick={handleClick} disabled={!(changePass.oldPass.length > 0 && changePass.newPass.length > 0 && changePass.reNewPass.length > 0 && changePass.newPass === changePass.reNewPass)}>
         ثبت اطلاعات
      </Button>
      </Box>

    </Card>
        
</Grid>
</Grid>
    </Box>
    <Dialog
              open={changePass.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={changePass.boxType === 1 ? "error" : (changePass.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: changePass.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {changePass.boxType === 2 ?   
                <Button variant="contained" color='success' onClick={handleCloseMessageBoxLoadAgain}>
                       خب
                </Button>
                : 
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              }
              </DialogActions>
            </Dialog>
          

    <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت اطلاعات اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>
            {changePass.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }

    </ThemeProvider>
    </>
  );
}

export default ChangePass;